import { TMessage } from "types/transcript"

// FIXME: Composite key includes role, because message_id is duplicated between member and sk response messages
// Remove the composite key uses (for example in react lists) when the backend is fixed
//
// Returns an empty string (falsy) when message_id is absent so that callers using an
// `if (messageKey)` guard skip key-based dedup for those messages and always keep them.
// Concretely, suppress_first_message PlayVideo messages are never saved to the backend
// conversation history (C2-2210), so they arrive without a message_id. Returning a
// stable non-empty key for them caused every PlayVideo across every conversation to
// share the same key ("message-undefined-<role>"), silently dropping all but the first
// in the cross-conversation dedup inside useChatMessageList.
export const computeMessageKey = (message: TMessage): string => {
  if (!message.message_id) return ""
  return `message-${message.message_id}-${message.role}`
}
